// File: src/components/enum/saleEnums.ts

export enum TypeSaleStatus {
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}

export const TypeSaleStatusLabel: Record<TypeSaleStatus, string> = {
  [TypeSaleStatus.COMPLETED]: "Concluída",
  [TypeSaleStatus.CANCELED]: "Cancelada",
};

export const TypeSaleStatusColor: Record<TypeSaleStatus, string> = {
  [TypeSaleStatus.COMPLETED]: "#34d399",
  [TypeSaleStatus.CANCELED]: "#fb7185",
};

// CASH/PIX/CARD usam as mesmas chaves de FinancialPaymentMethod de propósito
// — o valor mapeia direto na hora de liquidar, sem tabela de conversão.
export enum TypeSaleType {
  CASH = "CASH",
  PIX = "PIX",
  CARD = "CARD",
  DEFERRED = "DEFERRED",
}

export const TypeSaleTypeLabel: Record<TypeSaleType, string> = {
  [TypeSaleType.CASH]: "Dinheiro",
  [TypeSaleType.PIX]: "Pix",
  [TypeSaleType.CARD]: "Cartão",
  [TypeSaleType.DEFERRED]: "A Prazo",
};

export const TypeSaleTypeColor: Record<TypeSaleType, string> = {
  [TypeSaleType.CASH]: "#34d399",
  [TypeSaleType.PIX]: "#38bdf8",
  [TypeSaleType.CARD]: "#a78bfa",
  [TypeSaleType.DEFERRED]: "#f59e0b",
};
